var heading_default = {
  "fontElementMap": "_0uzZ9",
  "elementSpacing": "KY5t2",
  "headerOne": "lDt-W KY5t2",
  "headerTwo": "mt67e KY5t2",
  "headerThree": "jI-v1 KY5t2",
  "headerFour": "U51U1 KY5t2",
  "headerFive": "vz4Zr KY5t2",
  "headerSix": "OlnAh KY5t2",
  "child": "BvYOl"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
